import React, { ChangeEvent, useEffect, useState } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { NeuInput, NeuInputProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';
import { formatPhoneNumber } from './utils';

export interface FormPhoneInputProps extends NeuInputProps {
  name: string;
}

export const FormPhoneInput = ({
  name,
  required,
  label,
  ...rest
}: FormPhoneInputProps): JSX.Element => {
  const [maskedValue, setMaskedValue] = useState('');

  const {
    control,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  const fieldValue = watch(name);

  useEffect(() => {
    setMaskedValue(formatPhoneNumber(fieldValue));
  }, [fieldValue]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <NeuInput
          label={required ? `${label} ${REQUIRED_SYMBOL}` : label}
          required={required}
          value={maskedValue}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const formatted = formatPhoneNumber(e.currentTarget.value);
            setMaskedValue(formatted);
            field.onChange(formatted);
          }}
          onNeuBlur={() => trigger(name)}
          invalid={errorMessage}
          error={!!errorMessage}
          {...rest}
        />
      )}
    />
  );
};
